import { LOCAL_STORAGE_CUSTOM_LEVELS } from "./consts";
import { LevelMap } from "../levels/LevelMap";

export const saveLevelLocally = (id, data) => {
  //Update in-memory map
  LevelMap[id] = data;

  //Update local storage
  const localLevelsString =
    window.localStorage.getItem(LOCAL_STORAGE_CUSTOM_LEVELS) || "{}";

  const parsedCustomLevels = JSON.parse(localLevelsString);
  const newCustomLevels = {
    ...parsedCustomLevels,
    [id]: data,
  };

  window.localStorage.setItem(
    LOCAL_STORAGE_CUSTOM_LEVELS,
    JSON.stringify(newCustomLevels)
  );
};
